import type { FC } from 'react';
import { Route, type RouteProps, Switch } from 'react-router-dom';

import { FullPageContent } from '@/components/layout/full-page-content';
import { Dashboard } from '@/components/looker/dashboard';
import { useMe } from '@/hooks/use-me';

export const CustomDashboardsPage: FC<RouteProps> = () => {
  const me = useMe();

  return (
    <>
      <Switch>
        {me.config.customDashboards.map(({ path, dashboardId }) => (
          <Route key={path} path={`/custom/${path}`} exact>
            <FullPageContent>
              <Dashboard id={dashboardId} />
            </FullPageContent>
          </Route>
        ))}
      </Switch>
    </>
  );
};
